import { useState, useEffect } from "react";
import { markInternalNavigation } from "@/utils/attributionCapture";
import "./BannerCarousel.css";
const BannerCarousel = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [progress, setProgress] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const slides = [
    {
      title: "Sell Your Home",
      description:
        "Showcase your property to a nationwide audience of motivated buyers. Hubzu's streamlined auction process helps you market and sell residential properties with ease. Join Hubzu's Signature Homes Program for free today!",
      primaryBtn: { text: "Sell a Home", link: "/sellahomeinanonlineauction" },
      secondaryBtn: { text: "View Current Auctions", link: "/auctions?listingType=AUCN&propertyStatus=ACTIVE&sid=signature-seller&sid=offmarket-properties" },
      bgColor: "#118BF4",
      imagePosition: "right",
    },
    {
      title: "Sell Your Commercial Property",
      description:
        "Market your office, retail, or multifamily property to a nationwide audience of buyers. Hubzu's streamlined auction process helps you move commercial assets faster.",
      primaryBtn: { text: "Sell a Commercial Property", link: "/sell-commercial" },
      secondaryBtn: { text: "View Current Commercial Auctions", link: "/commercial" },
      bgColor: "#63938E",
      imagePosition: "left",
    },
    {
      title: "Hubzu Resources",
      description:
        "Explore our help section to learn more about buying and selling through Hubzu. From auction guides to FAQs, we've got the tools to help you every step of the way.",
      primaryBtn: { text: "Visit Help Page", link: "/support" },
      secondaryBtn: { text: "Visit the Hubzu Blog", link: "/blog" },
      bgColor: "#8FB035",
      imagePosition: "right",
    },
  ];

  useEffect(() => {
    if (isPaused) return;

    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          setActiveSlide((current) => (current + 1) % slides.length);
          return 0;
        }
        return prev + 2;
      });
    }, 100);

    return () => clearInterval(progressInterval);
  }, [isPaused, slides.length]);

  useEffect(() => {
    setProgress(0);
  }, [activeSlide]);

  return (
    <section
      className="banner-carousel"
      style={{ background: slides[activeSlide].bgColor, '--slide-bg-color': slides[activeSlide].bgColor }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="banner-carousel__container">
        {slides.length > 1 && (
          <div className="banner-carousel__dots">
            {slides.map((_, index) => (
              <button
                key={index}
                id={`banner-carousel-dot-${index}`}
                className={`banner-carousel__dot ${index === activeSlide ? "banner-carousel__dot--active" : ""}`}
                onClick={() => setActiveSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}
        <div className={`banner-carousel__wrapper banner-carousel__wrapper--${slides[activeSlide].imagePosition}`}>
          <div className="banner-carousel__content">
            <h2 className="banner-carousel__title">{slides[activeSlide].title}</h2>
            <p className="banner-carousel__description">{slides[activeSlide].description}</p>
            <div className="banner-carousel__buttons">
              <a href={slides[activeSlide].primaryBtn.link} id={`banner-carousel-primary-btn-${activeSlide}`} className="banner-carousel__btn banner-carousel__btn--primary" target="_blank" rel="noopener noreferrer">
                {slides[activeSlide].primaryBtn.text}
              </a>
              <a href={slides[activeSlide].secondaryBtn.link} id={`banner-carousel-secondary-btn-${activeSlide}`} className="banner-carousel__btn banner-carousel__btn--secondary" target="_blank" rel="noopener noreferrer" onClick={() => markInternalNavigation()}>
                {slides[activeSlide].secondaryBtn.text}
              </a>
            </div>
          </div>
          <div className="banner-carousel__image">
            <img
              key={`desktop-${activeSlide}`}
              src={`/assets/images/home/slide-${activeSlide + 1}.webp`}
              alt={slides[activeSlide].title}
              className="banner-carousel__image--desktop"
            />
            <img
              key={`mobile-${activeSlide}`}
              src={`/assets/images/home/mb-slide${activeSlide + 1}.png`}
              alt={slides[activeSlide].title}
              className="banner-carousel__image--mobile"
            />
          </div>
        </div>
        <div className="banner-carousel__progress-bar">
          <div className="banner-carousel__progress-fill" style={{ width: `${progress}%` }}></div>
        </div>
      </div>
    </section>
  );
};

export default BannerCarousel;
